import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Amenities from "@/components/Amenities";
import Location from "@/components/Location";
import Owners from "@/components/Owners";
import Reviews from "@/components/Reviews";
import InquiryForm from "@/components/InquiryForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#FAF7F2] text-[#232E26]">
      <Header />
      <Hero />
      <Gallery />
      <About />
      <Amenities />
      <Location />
      <Owners />
      <Reviews />
      <InquiryForm />
      <Footer />
    </main>
  );
}
